/* Full screen picture viewer for help-center articles.
 *
 * Ported from HELP-CENTER/build_mock.py, where the behaviour was designed and reviewed.
 * The manager asked for it twice: a drawing capped at 34rem in an 820px column is too
 * small to find a lever on a phone.
 *
 * Ships together with sections/ergonix-pagalba-article-foot.liquid, which carries the
 * matching .pagalba-lb CSS and the #pagalba-lb-strings element this reads its copy from.
 * Neither half works alone (SENSITIVE-CONTRACTS.md #1: bundles ship together).
 *
 * The overlay is built once and appended to document.body, so opening a picture never
 * inserts nodes into the article and never disturbs a playing clip.
 *
 * Class prefix is .pagalba-lb, not the mock's .lightbox, so nothing else on the
 * storefront can claim the name.
 */
(function () {
  'use strict';

  var figures = document.querySelector('.article-body .fig-img');
  if (!figures) { return; }   // not a help article, or an article with no pictures

  /* Copy comes from the section through data attributes, the same way
     ergonix-pagalba.js takes its search strings, so the viewer is translatable
     without touching this file. The fallbacks are Lithuanian because the whole
     help center is gated to the lt market until a localized set exists. */
  var S = document.getElementById('pagalba-lb-strings');
  function str(name, fallback) {
    var v = S && S.dataset ? S.dataset[name] : '';
    return v || fallback;
  }

  var box = document.createElement('div');
  box.className = 'pagalba-lb';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', str('label', 'Padidintas paveikslėlis'));
  var shot = document.createElement('img');
  shot.draggable = false;   // otherwise a drag starts the browser's own image drag
  var close = document.createElement('button');
  close.className = 'pagalba-lb-close';
  close.type = 'button';
  close.setAttribute('aria-label', str('close', 'Uždaryti'));
  close.innerHTML = '&times;';
  var hint = document.createElement('span');
  hint.className = 'pagalba-lb-hint';
  hint.textContent = str('hintMouse', 'Ratuku priartink, tempk pelę, kad pastumtum');
  var bar = document.createElement('div');
  bar.className = 'pagalba-lb-bar';
  var count = document.createElement('span');
  count.className = 'pagalba-lb-count';
  var cap = document.createElement('span');
  cap.className = 'pagalba-lb-cap';
  bar.appendChild(count);
  bar.appendChild(cap);
  bar.appendChild(hint);
  var prev = document.createElement('button');
  prev.className = 'pagalba-lb-step pagalba-lb-prev';
  prev.type = 'button';
  prev.setAttribute('aria-label', str('prev', 'Ankstesnis paveikslėlis'));
  prev.innerHTML = '&#8249;';
  var next = document.createElement('button');
  next.className = 'pagalba-lb-step pagalba-lb-next';
  next.type = 'button';
  next.setAttribute('aria-label', str('next', 'Kitas paveikslėlis'));
  next.innerHTML = '&#8250;';
  box.appendChild(shot);
  box.appendChild(close);
  box.appendChild(prev);
  box.appendChild(next);
  box.appendChild(bar);
  document.body.appendChild(box);

  // Touch has no wheel and no mouse to drag with; there a tap steps in and out and a
  // swipe moves between pictures, because the arrows are hidden at phone width.
  if (matchMedia('(hover: none)').matches) {
    hint.textContent = str('hintTouch', 'Bakstelėk, kad priartintum. Braukk, kad pereitum prie kito');
  }

  var opener = null;
  var group = [];
  var at = 0;

  function captionOf(img) {
    var figure = img.closest ? img.closest('.fig') : null;
    var label = figure ? figure.querySelector('.fig-cap') : null;
    if (!label) { return img.alt || ''; }
    /* The step number is its own element, a disc, so textContent runs it straight into
       the sentence and gives "3Prisuk kojų pagrindus". Read the two parts separately. */
    var disc = label.querySelector('.fig-step');
    var text = '';
    Array.prototype.forEach.call(label.childNodes, function (node) {
      if (node !== disc) { text += node.textContent; }
    });
    text = text.replace(/\s+/g, ' ').trim();
    return disc ? disc.textContent.trim() + '. ' + text : text;
  }

  function load(img) {
    shot.src = img.currentSrc || img.src;
    shot.alt = img.alt || '';
    opener = img;
    cap.textContent = captionOf(img);
    count.textContent = group.length > 1 ? (at + 1) + ' / ' + group.length : '';
    prev.hidden = next.hidden = group.length < 2;
    scale = 1;
    shot.style.width = '';
    box.classList.remove('is-zoomed');
    box.scrollTop = 0;
    box.scrollLeft = 0;
    if (shot.complete) { measureFit(); } else { shot.onload = measureFit; }
  }

  /* Step to the neighbouring picture. It stops at both ends rather than wrapping: a
     seven-step assembly that silently returns to step 1 reads as a bug, not as a loop. */
  function step(by) {
    if (group.length < 2) { return; }
    var to = at + by;
    if (to < 0 || to >= group.length) { return; }
    at = to;
    load(group[at]);
  }

  function open(img) {
    /* The pictures of this article, in reading order. Scoped to .article-body so the
       group can never pick up a thumbnail from the related-articles rail below. */
    var scope = (img.closest && img.closest('.article-body')) || document;
    group = Array.prototype.slice.call(scope.querySelectorAll('.fig-img'));
    at = Math.max(0, group.indexOf(img));
    // load() also resets the zoom, so a picture never opens inheriting the last one's.
    load(img);
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    close.focus();
  }

  function shut() {
    box.classList.remove('is-open');
    box.classList.remove('is-zoomed');
    scale = 1;
    shot.style.width = '';
    document.body.style.overflow = '';
    shot.removeAttribute('src');
    if (opener) { opener.focus(); opener = null; }
  }

  /* Zoom is a continuous scale, 1 meaning fit-to-screen, driven by the wheel and anchored
     under the pointer: the pixel you are pointing at stays put while the picture grows
     around it. That is the only way to work a drawing without losing the thing you were
     looking at. Touch has no wheel, so a tap still steps in and out. */
  var scale = 1;
  var MAX = 6;
  var fitW = 0;

  function measureFit() {
    box.classList.remove('is-zoomed');
    shot.style.width = '';
    fitW = shot.getBoundingClientRect().width || shot.naturalWidth || 0;
  }

  function applyScale(nextScale, clientX, clientY) {
    nextScale = Math.max(1, Math.min(MAX, nextScale));
    if (!fitW) { measureFit(); }
    if (nextScale === scale) { return; }

    if (nextScale === 1) {
      scale = 1;
      box.classList.remove('is-zoomed');
      shot.style.width = '';
      box.scrollLeft = 0;
      box.scrollTop = 0;
      return;
    }

    // Anchor off the picture's own rectangle, never off scrollLeft. While fitted, the
    // picture is flex-centred inside padding, so its left edge is not the container's
    // origin and scroll-based maths drifts a few percent per step.
    var was = shot.getBoundingClientRect();
    var ax = (clientX === undefined ? was.left + was.width / 2 : clientX);
    var ay = (clientY === undefined ? was.top + was.height / 2 : clientY);
    var fx = was.width ? (ax - was.left) / was.width : 0.5;
    var fy = was.height ? (ay - was.top) / was.height : 0.5;

    box.classList.add('is-zoomed');
    shot.style.width = (fitW * nextScale) + 'px';
    scale = nextScale;

    // Measure again and shift the scroll by however far that point actually moved.
    var now = shot.getBoundingClientRect();
    box.scrollLeft += (now.left + fx * now.width) - ax;
    box.scrollTop += (now.top + fy * now.height) - ay;
  }

  box.addEventListener('wheel', function (e) {
    if (!box.classList.contains('is-open')) { return; }
    e.preventDefault();                       // the page behind must not scroll
    var by = Math.exp(-e.deltaY * 0.0018);    // smooth, and symmetric in and out
    applyScale(scale * by, e.clientX, e.clientY);
  }, { passive: false });

  function toggleZoom(e) {
    applyScale(scale > 1 ? 1 : 2.5, e.clientX, e.clientY);
  }

  /* Drag to pan, for a mouse. Touch already pans by itself because the overlay scrolls, so
     this listens for mouse events only and never touches that path. A drag must not also
     count as a click, or letting go would toggle the zoom off every time. */
  var panning = false, startX = 0, startY = 0, fromLeft = 0, fromTop = 0, dragged = false;

  shot.addEventListener('mousedown', function (e) {
    if (!box.classList.contains('is-zoomed') || e.button !== 0) { return; }
    panning = true;
    dragged = false;
    startX = e.clientX;
    startY = e.clientY;
    fromLeft = box.scrollLeft;
    fromTop = box.scrollTop;
    box.classList.add('is-panning');
    e.preventDefault();               // stop the browser dragging the image as a file
  });

  document.addEventListener('mousemove', function (e) {
    if (!panning) { return; }
    var dx = e.clientX - startX;
    var dy = e.clientY - startY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) { dragged = true; }
    box.scrollLeft = fromLeft - dx;
    box.scrollTop = fromTop - dy;
  });

  document.addEventListener('mouseup', function () {
    if (!panning) { return; }
    panning = false;
    box.classList.remove('is-panning');
  });

  /* Swipe between pictures, but only while fitted. Once zoomed in, a horizontal drag is
     how a touch reader pans across the drawing, and stealing it for navigation would make
     the zoom useless on the one device the viewer exists for. */
  var swipeX = 0, swipeY = 0, swiping = false;

  box.addEventListener('touchstart', function (e) {
    swiping = e.touches.length === 1 && !box.classList.contains('is-zoomed');
    if (!swiping) { return; }
    swipeX = e.touches[0].clientX;
    swipeY = e.touches[0].clientY;
  }, { passive: true });

  box.addEventListener('touchend', function (e) {
    if (!swiping || !e.changedTouches.length) { return; }
    swiping = false;
    var dx = e.changedTouches[0].clientX - swipeX;
    var dy = e.changedTouches[0].clientY - swipeY;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { step(dx < 0 ? 1 : -1); }
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (e.target === prev || e.target === next) {
      step(e.target === next ? 1 : -1);
      return;
    }
    /* Only pictures inside the article body open. A clip is a <video>, not a .fig-img,
       so tapping one pauses it as it should instead of covering it. */
    var img = e.target.closest ? e.target.closest('.article-body .fig-img') : null;
    if (img) { open(img); return; }
    if (e.target === shot) {
      if (dragged) { dragged = false; return; }   // that was a pan, not a tap
      toggleZoom(e);
      return;
    }
    if (e.target === box || e.target === close) { shut(); }
  });

  document.addEventListener('keydown', function (e) {
    if (box.classList.contains('is-open') &&
        (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      e.preventDefault();
      step(e.key === 'ArrowRight' ? 1 : -1);
      return;
    }
    if (e.key === 'Escape' && box.classList.contains('is-open')) { shut(); }
    var img = document.activeElement;
    if ((e.key === 'Enter' || e.key === ' ') && img && img.classList &&
        img.classList.contains('fig-img')) {
      e.preventDefault();
      open(img);
    }
  });
})();
